module.exports = __webpack_public_path__ + "static/media/steps_to_the_garden.1d9c61d7.jpg";